import * as actionTypes from '../constants/userActionTypes';
import * as api from '../api';
import { toast } from "react-toastify";

/**
* function for loadUserProfile
* @param {*} data User data 
* @description get user infromation
* @param {function} loadUserProfile loadUserProfile function
*/
export const getChatUsers = (id) => async dispatch => {
    try {
        dispatch({ type: actionTypes.GET_CHAT_USERS_REQUEST })
        const  { data }  = await api.getChatUser(id);
        dispatch({ type: actionTypes.GET_CHAT_USERS_SUCCESS, payload: data })
    } catch (err) {
        console.log(err)
        dispatch({ type: actionTypes.GET_CHAT_USERS_FAIL, payload: err.response.data })
    }
}
/**
* function for loadUserProfile
* @param {*} data User data 
* @description get user infromation
* @param {function} loadUserProfile loadUserProfile function
*/
export const loadChats = (projectId, id = '') => async dispatch => {
    try {
        dispatch({ type: actionTypes.GET_CHAT_REQUEST })
        const  { data }  = await api.getChat(projectId, id);
        dispatch({ type: actionTypes.GET_CHAT_SUCCESS, payload: data })
    } catch (err) {
        console.log(err)
        dispatch({ type: actionTypes.GET_CHAT_FAIL, payload: err.response.data })
    }
}

/**
* function for user register
* @param {*} data form data and history
* @description user register
* @param {function} register register function
*/
export const sendMessage = (formData) => async dispatch => {
    try {
        dispatch({ type: actionTypes.SEND_MESSAGE_REQUEST })
        const { data } = await api.sendMessage(formData);
        toast.success(data.message);
        dispatch({ type: actionTypes.SEND_MESSAGE_SUCCESS, payload: data })
    } catch (err) {
        toast.error(err.response?.data?.message);
        dispatch({ type: actionTypes.SEND_MESSAGE_FAIL, payload: err.response?.data?.message })
    }
}